module.exports = __webpack_public_path__ + "img/ADX.97ced787.svg";